import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/13_classic-1/13_classic-1"
 * Contains 12 texture(s)
 */
export class CardsFront13Classic1Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/13_classic-1/13_classic-1';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'ace-spades.png',
        'ace-hearts.png',
        'ace-diamonds.png',
        'ace-clubs.png',
        '9-spades.png',
        '9-hearts.png',
        '9-diamonds.png',
        '9-clubs.png',
        '8-spades.png',
        '8-hearts.png',
        '8-diamonds.png',
        '8-clubs.png'
    ] as const;
}
